module.exports = __webpack_public_path__ + "static/media/cast.359988cf.png";